import { useEffect, useState } from "react"
import { raiseToast } from "../services/redux/reducers/toast/toast"
import { useDispatch } from "react-redux"


const EInvoiceDetails = (props) => {
    const { eInvoiceDetails } = props

    const [parsedEInvoice, setParsedEInvoice] = useState(undefined)

    const dispatch = useDispatch()

    useEffect(() => {
        getParsedEInvoiceDetails()
    }, [eInvoiceDetails])

    const getParsedEInvoiceDetails = async () => {
        const response = await fetch(eInvoiceDetails)
        if (!response.ok) {
            return dispatch(raiseToast({severity:'error', detail: "E Invoice fetching failed", life: 3000}))
        }
        const eInvoiceData = await response.json()

        let parsedEInvoiceData = {}
        if(eInvoiceData.SignedQRCode){
            let signedQRCodeArr = eInvoiceData.SignedQRCode.split('.')
            let signedQRCodePart2 = signedQRCodeArr[1]
            let extractedQRCodePart2 = atob(signedQRCodePart2)
            let parsedQRCodePart2 = JSON.parse(extractedQRCodePart2)
            let qrcodeData = parsedQRCodePart2.data
            qrcodeData = JSON.parse(qrcodeData)
            parsedEInvoiceData = qrcodeData
        }
        parsedEInvoiceData.QrCodeImage = eInvoiceData.QrCodeImage

        setParsedEInvoice(parsedEInvoiceData)
    }

    return (
        <>
            {
                parsedEInvoice ?
                <div className=''>
                    <p><span className="font-semibold">Irn: </span>{parsedEInvoice.Irn}</p>
                    <div className="flex justify-content-between">
                        <div className='col s6' style={{ padding: 0 }}>
                            <p style={{ margin: 0 }}><span className="font-semibold">SellerGstin: </span>{parsedEInvoice.SellerGstin}</p>
                        </div>
                        <div className='col s6' style={{ padding: 0 }}>
                            <p style={{ margin: 0 }}><span className="font-semibold">BuyerGstin: </span>{parsedEInvoice.BuyerGstin}</p>
                        </div>
                    </div>

                    <div className='flex justify-content-between'>
                        <div className='col s6' style={{ padding: 0 }}>
                            <p><span className="font-semibold">Irn Date: </span>{parsedEInvoice.IrnDt}</p>
                            <p><span className="font-semibold">Doc Date: </span>{parsedEInvoice.DocDt}</p>
                            <p><span className="font-semibold">Doc No: </span>{parsedEInvoice.DocNo}</p>
                            <p><span className="font-semibold">Doc Type: </span>{parsedEInvoice.DocTyp}</p>
                            <p><span className="font-semibold">Item Count: </span>{parsedEInvoice.ItemCnt}</p>
                            <p><span className="font-semibold">Main Hsn Code: </span>{parsedEInvoice.TotInvVal}</p>
                            <p><span className="font-semibold">Total Invoice Value: </span>{parsedEInvoice.TotInvVal}</p>
                        </div>
                        <div className='' style={{ padding: 0 }}>
                            {parsedEInvoice.QrCodeImage ?
                                <div>
                                    <img
                                        className=""
                                        src={`data:image/png;base64,${parsedEInvoice.QrCodeImage}`}
                                        alt="EInvoice QRCode"
                                    />
                                </div>
                                : ""}
                        </div>
                    </div>
                </div> :
                null
            }
        </>
    )
}

export default EInvoiceDetails